<template>

    <div class="share-controls" :class="{ 'open': activeShare }">

        <div class="addthis_toolbox addthis_default_style addthis_32x32_style">
            <a class="addthis_button_facebook"
               addthis:service="facebook"
               :addthis:url="shareUrl"
               :addthis:title="shareMessage"
               :addthis:description="shareMessage"
               v-if="(shareData.facebook === '1')"
               @click="closeShares"
               title="Share on Facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a>

            <a class="addthis_button_linkedin"
               addthis:service="linkedin"
               :addthis:url="shareUrl"
               :addthis:title="shareTitle"
               :addthis:description="shareMessage"
               v-if="(shareData.linkedin === '1')"
               @click="closeShares"
               title="Share on LinkedIn"><i class="fa fa-linkedin" aria-hidden="true"></i></a>

            <a class="addthis_button_twitter"
               addthis:service="twitter"
               :addthis:url="shareUrl"
               :addthis:title="shareMessage"
               :addthis:description="shareMessage"
               v-if="(shareData.twitter === '1')"
               @click="closeShares"
               title="Share on Twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a>

            <a class="addthis_button_google_plusone_share"
               addthis:service="googleplus"
               :addthis:url="shareUrl"
               :addthis:title="shareMessage"
               :addthis:description="shareMessage"
               v-if="(shareData.google_plus === '1')"
               @click="closeShares"
               title="Share on Google+"><i class="fa fa-google-plus" aria-hidden="true"></i></a>

            <a class="addthis_button_email"
               addthis:service="email"
               :addthis:url="shareUrl"
               :addthis:title="shareTitle"
               :addthis:description="shareMessage"
               :addthis:note="shareMessage"
               v-if="(shareData.email === '1')"
               @click="closeShares"
               title="Share via Email"><i class="fa fa-envelope" aria-hidden="true"></i></a>
        </div>

    </div>

</template>


<script>
    let vm = {};

    export default {

        name: 'share-controls',

        components: {},

        data() {
            return {
                open: false
            }
        },

        computed: {

            activeShare() {
                return this.$dataStore.getters.getActiveShare;
            },

            shareData() {
                return this.$dataStore.getters.getShareData;
            },

            shareUrl() {
                return window.location.href;
            },

            shareMessage() {
                return this.shareData.message;
            },

            shareTitle() {
                let cData = this.$dataStore.getters.getCompany;
                return cData.company_name + ' Residential Microsite';
            }

        },

        created() {

            vm = this;

            this.$eventBus.$on('share:toggle', function() {
                vm.$dataStore.dispatch('ACTIVE_SHARE', { val: !vm.activeShare });
            });

            this.$eventBus.$on('share:close', function() {
                vm.$dataStore.dispatch('ACTIVE_SHARE', { val: false });
            });

        },

        mounted() {

            vm = this;

            addthis.init();
            addthis.toolbox('.addthis_toolbox');

        },

        methods: {

            clickOutside(evt) {
                evt.preventDefault();
                document.removeEventListener('click', vm.clickOutside, false);
                this.$dataStore.dispatch('ACTIVE_SHARE', { val: false });
            },

            closeShares() {
                vm.$dataStore.dispatch('ACTIVE_SHARE', { val: false });
            }

        },

        watch: {

            activeShare: function(nVal) {
                if (nVal) {
                    setTimeout(function() {
                        document.addEventListener('click', vm.clickOutside, false);
                    }, 1500);
                } else {
                    document.removeEventListener('click', vm.clickOutside, false);
                }
            }

        }
    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .share-controls {
        width: 36px;
        opacity: 0;
        visibility: hidden;
        position: absolute;
        top: -20px;
        left: -37px;
        transition: all 0.3s $easeInOutQuad;

        &.open {
            opacity: 1;
            visibility: visible;
            transition: all 0.3s $easeInOutQuad;
        }

        & .addthis_toolbox {
            margin: 0 0 0 0;
            padding: 0 0 0 0;
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: center;

            & > a {
                text-decoration: none;
                width: 36px;
                height: 36px;
                margin: 0 0 1px 0;
                padding: 0 0 0 0;
                display: flex;
                justify-content: center;
                position: relative;

                &.addthis_button_facebook {
                    background-color: rgba(59,89,152, 1.0);
                }

                &.addthis_button_linkedin {
                    background-color: rgba(0,119,181, 1.0);
                }

                &.addthis_button_twitter {
                    background-color: rgba(29,161,242, 1.0);
                }

                &.addthis_button_google_plusone_share {
                    background-color: rgba(221,75,57, 1.0);
                }

                &.addthis_button_email {
                    background-color: rgba(132,132,132, 1.0);
                }

                & .fa {
                    color: $white-100;
                    align-self: center;
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// ShareControls.vue?3bd73cec